import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './layout';

import FetchCall from '../../API/FetchCall';

import { AddSuppliers, getLocationList } from '../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';
import { Modal, ModalBody, Row, Col, ModalFooter } from 'reactstrap';

class verticalEventsDetail extends Component {

     constructor(props) {
        super(props);
        this.state = {
            partyDetails: [],
        };
        this.id = this.props.match.params.id;
        this.type = this.props.match.params.type;
        this.getEventsInfo = this.getEventsInfo.bind(this);
        this.getEventsInfo();

    }

    componentDidMount() {
        this.getEventsInfo();
    }

    UNSAFE_componentWillMount() {

    }

    componentDidUpdate() {
    }

    async getEventsInfo() {
        let response = await FetchCall.getEventsInfo(this.id, this.type);
        if (response) {
            const data = response.data;
            this.setState({
                partyDetails: data,
                url: data.url,
                photos_arr: data.photo_arr,
            });

        } else {
            return <div>Error</div>;
        }
    }


    gallery_image() {

        let photos = this.state.photos_arr !== undefined ? this.state.photos_arr : [];
        let rows = "";
        if (photos.length > 0) {
            rows = photos.map((photos, index) => {
                if (photos.name)
                    return (
                        <div class="col-md-4 float-left mt-4 p-0">
                            <img src={this.state.url + photos.name} alt="Img" class="img-thumbnail" />
                        </div>
                    );
            });
        } else {
            rows = "";
        }
        return rows;

    }


    render() {

        const { partyDetails } = this.state;
        console.log('partyDetails', this.state);
        let entatainer = '';
        if (this.type === 'supplier') {
            switch (partyDetails.entatainer) {
                case "1":
                    entatainer = 'Birthday party';
                    break;
                case "2":
                    entatainer = 'Dj';
                case "1,2":
                    entatainer = 'Birthday party, Dj';
                    break;
                default:
                    entatainer = partyDetails.entatainer;
            }
        }


        return (
            <React.Fragment>
                <AdminLayout>
                    
           <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">{partyDetails.name} - View</h4>
                                   
                  <div class="pt-3 detailsection">
                        
                            <div id="company-info" className="tab-pane fade in active">
                                            <form className="custom-form invoice-form col-md-12 col-xs-12 legend-form pad-no">
                                                <div className="box-shadow-custom">
                                                    <div className="row">
                                                        <div className="form-group col-md-4">
                                                            <label>Registration No.</label>
                                                            <p>{partyDetails.registration_no}</p>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Name</label>
                                                            <p>{partyDetails.name}</p>
                                                        </div>

                                                        {/* <div className="form-group col-md-4">
                                                                
                                                                <label className="text-capitalize"> Invitees</label>
                                                                <p>{partyDetails.sub_categories}</p>
                                                            </div> */}

                                                    </div>
                                                </div>

                                                <div className="box-shadow-custom">
                                                    <div className="row">
                                                        <div className="col-md-12 col-xs-12">
                                                            <span className="form-legend">Key Information</span>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Contact Person</label>
                                                            <p>{partyDetails.contact_person}</p>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Email Id</label>
                                                            <p>{partyDetails.email_id}</p>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Phone No.</label>
                                                            <p>{partyDetails.phone_number}</p>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>State</label>
                                                            <p>{partyDetails.state}</p>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Location</label>
                                                            <p>{partyDetails.location}</p>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Website</label>
                                                            <p>{partyDetails.website}</p>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Facebook</label>
                                                            <p>{partyDetails.facebook}</p>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Type</label>
                                                            <p>{partyDetails.typname}</p>
                                                        </div>

                                                        <div className="form-group col-md-4">
                                                            <label>Twitter</label>
                                                            <p>{partyDetails.twitter}</p>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Avg Price </label>
                                                            <p>{partyDetails.event_fee}</p>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Established Year </label>
                                                            <p>{partyDetails.est_year}</p>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Pincode</label>
                                                            <p>{partyDetails.pincode}</p>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>
                                                                Modes of Payment
                                                            </label>
                                                            <p>{partyDetails.mod_payment}</p>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Food</label>
                                                            <p>{partyDetails.food}</p>
                                                        </div>

                                                        <div className="form-group col-md-4">
                                                            <label>Hall Capacity</label>
                                                            <p>{partyDetails.hall_capcity}</p>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Dinning Hall Capacity</label>
                                                            <p>{partyDetails.dinning_capacity}</p>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Car Parking</label>
                                                            <p>{partyDetails.car_parking_slot}</p>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Two Wheeler Parking</label>
                                                            <p>{partyDetails.two_parking_slot}</p>
                                                        </div>

                                                        <div className="form-group col-md-4">
                                                            <label>Address</label>
                                                            <p>{partyDetails.address}</p>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Google Location Address</label>
                                                            <p>{partyDetails.google_location}</p>
                                                        </div>
                                                        {(partyDetails.vendor_id == 1 && (
                                                            <div className="form-group col-md-4">
                                                                <label>Partner Type</label>
                                                                <p>{partyDetails.partner_type == 1 ? 'Institution' : 'Individual'}</p>
                                                            </div>
                                                        ))}
                                                        <div className="form-group col-md-4">
                                                            <label>Operating hours</label>
                                                            <p>{partyDetails.timing}</p>
                                                        </div>
                                                        <div className="form-group col-md-12">
                                                            <label>About</label>
                                                            <p>{partyDetails.about}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="box-shadow-custom">
                                                    <div className="row">
                                                        <div className="col-md-12 col-xs-12">
                                                            <span className="form-legend">Other Information</span>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Other Info </label>
                                                            <p>{partyDetails.other_info}</p>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Website Search Keywords</label>

                                                            <p>{partyDetails.keywords}</p>
                                                        </div>
                                                    </div>



                                                </div>

                                                <div className="box-shadow-custom">
                                                    <div className="row">
                                                        <div className="col-md-12 col-xs-12">
                                                            <span className="form-legend">Images</span>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <label>Banner </label>
                                                            {partyDetails.images &&
                                                                <img src={partyDetails.url + partyDetails.images} alt="Img" class="img-thumbnail" />
                                                            }
                                                        </div>



                                                        <div class="col-md-12 float-left mt-4 p-0">
                                                            <label>
                                                                Gallery Images
                                                            </label>
                                                        </div>


                                                        {this.gallery_image()}
                                                    </div>
                                                </div>

                                            </form>
                                        </div>
                  </div>
                </div>
              </div>
            </div>

                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default verticalEventsDetail;


// WEBPACK FOOTER //
// ./src/components/bewise/verticalEventsDetail.jsx